// Wolsey product page — tab navigation
// Accessible WAI-ARIA tablist with arrow-key navigation.

(function () {
  'use strict'

  function activate(tab) {
    const tablist = tab.closest('[role="tablist"]')
    if (!tablist) return
    const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'))
    const container = tablist.parentElement

    tabs.forEach((t) => {
      const isThis = t === tab
      t.setAttribute('aria-selected', String(isThis))
      t.setAttribute('tabindex', isThis ? '0' : '-1')
      t.classList.toggle('c-product-page__tab--active', isThis)

      const panelId = t.getAttribute('aria-controls')
      const panel = panelId ? container.querySelector('#' + panelId) : null
      if (panel) {
        panel.classList.toggle('c-product-page__tabpanel--active', isThis)
        if (isThis) panel.removeAttribute('hidden')
        else panel.setAttribute('hidden', '')
      }
    })
  }

  function init(tablist) {
    const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'))

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault()
        activate(tab)
        tab.focus()
      })

      tab.addEventListener('keydown', (e) => {
        let target = null
        if (e.key === 'ArrowRight') target = tabs[(i + 1) % tabs.length]
        else if (e.key === 'ArrowLeft') target = tabs[(i - 1 + tabs.length) % tabs.length]
        else if (e.key === 'Home') target = tabs[0]
        else if (e.key === 'End') target = tabs[tabs.length - 1]
        if (target) {
          e.preventDefault()
          activate(target)
          target.focus()
        }
      })
    })
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn)
    else fn()
  }

  ready(() => {
    document.querySelectorAll('.c-product-page__tabs[role="tablist"]').forEach(init)
  })
})()
